import { __assign, __makeTemplateObject } from "tslib";
import React, { forwardRef } from 'react';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { StyledFormHelperText } from './styles';
import { RcFormHelperTextClasses } from './utils';
var _RcFormHelperText = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcFormHelperText' });
    var classes = props.classes, children = props.children;
    return (React.createElement(StyledFormHelperText, __assign({}, props, { ref: ref, classes: combineClasses(RcFormHelperTextClasses, classes) }), children));
});
var RcFormHelperText = styled(_RcFormHelperText)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
RcFormHelperText.defaultProps = {};
RcFormHelperText.displayName = 'RcFormHelperText';
export { RcFormHelperText };
var templateObject_1;
